import {NgModule} from "@angular/core";
import {VisitTasksService} from "./services/tasks/tasks.service";

@NgModule({
  providers: [
    VisitTasksService
  ]
})
export class SellionsVisitTaskModule {
}



// WEBPACK FOOTER //
// ./src/modules/engine/engine.module.ts